import * as React from 'react';

import {Button} from 'shells/button/button';
import {FormField} from 'shells/form/form-field';
import {LocationPinRegularIcon} from 'shells/icon/svg/location-pin-regular-icon';
import {VideoCameraRegularIcon} from 'shells/icon/svg/video-camera-regular-icon';
import {IconSection} from 'shells/icon-section/icon-section';
import {LinkWithCopyButton} from 'shells/link/link-with-copy-button';
import {TextField} from 'shells/textfield/textfield';

import styles from './calendar.module.css';

type Props = {
    location: string;
    onChange: (newLocation: string) => void;
    meetingUrl: string | null | undefined;
    isReadOnly?: boolean;
};

export function LocationSection(props: Props) {
    const {isReadOnly = false} = props;
    const [showLocationField, setShowLocationField] = React.useState(!props.meetingUrl);

    const handleLocationBlur = () => {
        // Hide the location field if nothing is typed
        if (props.location.trim() === '') {
            setShowLocationField(false);
        }
    };

    const handleAddPhysicalLocation = () => {
        setShowLocationField(true);
    };

    // Show option to add physical location when there is a meeting URL and no location
    if (props.meetingUrl && !showLocationField && !props.location) {
        return (
            <IconSection icon={VideoCameraRegularIcon} marginTopValue={2}>
                <div className={styles['meeting-section']}>
                    <LinkWithCopyButton
                        link={props.meetingUrl}
                        size='small'
                        buttonHasBorder={true}
                        shouldTruncate={true}
                    />
                    {!isReadOnly && (
                        <Button
                            variant='text-primary'
                            size='small'
                            onClick={handleAddPhysicalLocation}
                            noPadding={true}
                        >
                            + Add location
                        </Button>
                    )}
                </div>
            </IconSection>
        );
    }

    // Show location field (either there's no meeting URL or user wants to add location)
    return (
        <div className='flex flex-dir-col gap-16'>
            {props.meetingUrl && (
                <IconSection icon={VideoCameraRegularIcon} marginTopValue={2}>
                    <div className={styles['location-field']}>
                        <LinkWithCopyButton
                            link={props.meetingUrl}
                            size='small'
                            buttonHasBorder={true}
                            shouldTruncate={true}
                        />
                    </div>
                </IconSection>
            )}
            <IconSection icon={LocationPinRegularIcon}>
                <div className={styles['location-field']}>
                    <FormField innerId='location' noMargin={true} isFullWidth={true}>
                        <TextField
                            placeholder='Add a location'
                            value={props.location}
                            onChange={props.onChange}
                            // @ts-expect-error
                            onBlur={handleLocationBlur}
                            multiline={true}
                            rows={2}
                            disabled={isReadOnly}
                            autoFocus={true}
                        />
                    </FormField>
                </div>
            </IconSection>
        </div>
    );
}
